'use client';

import { useContext, useState } from 'react';
import { FieldError, get, useFormContext } from 'react-hook-form';
import { twMerge } from 'tailwind-merge';

import { PropsWithClasses } from '@lamesarv-sdk/types';

import { CommonFormContext } from '.';

interface ICommonTextareaProps extends PropsWithClasses {
  name: string;
  label?: string;
  hideLabel?: boolean;
  isRequired?: boolean;
  placeholder?: string;
  classContainer?: string;
  classLabel?: string;
  classLabelWithValue?: string;
  classInputWithValue?: string;
}

export const CommonTextarea = (props: ICommonTextareaProps) => {
  const [value, setValue] = useState<string>();

  const {
    register,
    formState: { errors },
  } = useFormContext();
  const { isDisabled } = useContext(CommonFormContext);

  const error = get(errors, props.name) as FieldError | null;

  return (
    <div className={twMerge('flex flex-col gap-1.5 group', isDisabled && 'opacity-60', props.classContainer)}>
      {!props.hideLabel && (
        <span className={twMerge('text-sm text-black-500', props.classLabel, !!value && props.classLabelWithValue)}>
          {props.label}
          {props.isRequired && <span className="text-red-700 leading-none"> *</span>}
        </span>
      )}
      <textarea
        className={twMerge(
          'border border-black-200 rounded-sm px-3 py-2 placeholder-black-350 text-black-500 min-h-20',
          props.classInput,
          !!value && props.classInputWithValue,
          error && 'border-red-700 placeholder-red-400 text-red-700',
        )}
        placeholder={props.placeholder}
        {...register(props.name)}
        disabled={isDisabled}
        onChange={(event) => {
          setValue(event.target.value);
        }}
      />
      {error && <span className="text-left text-red-700 text-sm">{error.message}</span>}
    </div>
  );
};
